import { Badge } from 'antd';
import { Query } from 'react-apollo';
import { useGlobal } from 'reactn';
import { GET_TIMESHEETS_FOR_APPROVAL } from '../../../project-manager/queries';
import { IGlobalState } from '../../../timesheets/components/Calendar/types';

interface UserEmail {
  address: string;
}

interface User {
  emails: UserEmail[];
}

interface ApprovalRequired {
  status: string;
  approvedOn?: string;
  approvedBy?: string;
  canApprove: string[];
  approvers: Array<{
    firstName: string;
    lastName: string;
    imageUrl?: string;
    emails: UserEmail[];
  }>;
}

interface Timesheet {
  _id: string;
  approvalsRequired: ApprovalRequired[];
  // ...other fields as needed
}

interface QueryData {
  projectManagement?: {
    timesheets?: Timesheet[];
  };
}

const ApprovalBadgeCounter = () => {
  const [global] = useGlobal<IGlobalState>();
  const user = global.user as User;
  if (!user || !user.emails || user.emails.length === 0) return null;
  const userEmail = user.emails[0].address;

  return (
    <Query<QueryData> query={GET_TIMESHEETS_FOR_APPROVAL}>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      {({ loading, error, data }: { loading: boolean; error?: Error; data?: QueryData }) => {
        // if (error) throw new Error(error);
        if (error) return null;
        const timesheets = data?.projectManagement?.timesheets || [];
        const approvalCount = timesheets?.filter((t: Timesheet) => {
          let myApprovalsRequired = t.approvalsRequired?.filter((approval: ApprovalRequired) =>
            approval?.canApprove?.includes(userEmail),
          );
          myApprovalsRequired = myApprovalsRequired?.filter((approval: ApprovalRequired) => !approval.approvedBy);
          return myApprovalsRequired?.length > 0;
        })?.length || null;
        return approvalCount && <Badge count={approvalCount} />;
      }}
    </Query>
  );
};

export default ApprovalBadgeCounter;
